import { Injectable } from '@angular/core';


/**
 * Spinner service that provides the spinner urls.
 * 
 * Note: if you are looking to add a spinner, there is now a spinner component (SpinnerComponent) and can be
 * used like: 
 * <spinner id="price-load-spinner" messageRelativePosition="bottom"> </spinner>
 */
@Injectable()
export class SpinnerService {
  constructor() {}

  /**
   * Gets a url for the large spinner.  This is the default spinner (loading-lg.gif)
   */
  getLargeSpinnerUrl() {
    return '/assets/images/ring-alt.svg';
  }

  /**
   * Gets a url for the magnifying glass (search).  Use on search components when
   * querying listing service
   */
  getMagnifySpinnerUrl() {
    return '/assets/images/ring-alt.svg';
  }

}
